export default __webpack_public_path__ + "static/media/studyMaterialIcon.873496a6.svg";